import React, { useState, useCallback, useEffect, useRef } from "react";
import { ElementRoot } from "./ElementRoot.jsx";
import { mediaElementShape } from "./shapes/index.jsx";

const initialState = {
  zoom: false,
  scrollX: 0,
  scrollY: 0,
};

export const ImagePreview = ({ url }) => {
  const imageRef = useRef(null);
  const containerRef = useRef(null);
  const [loaded, setLoaded] = useState(false);
  const [state, setState] = useState(initialState);

  const handleLoad = useCallback(() => {
    setLoaded(true);
  }, [setLoaded]);

  // @TODO: implement zoom logic
  const zoomImage = useCallback((event) => {
    let offsetX = event.nativeEvent.offsetX;
    let offsetY = event.nativeEvent.offsetY;

    setState(({ zoom }) => {
      let scrollX = 0;
      let scrollY = 0;

      if (!zoom) {
        let previewWith = imageRef.current.offsetWidth;
        let previewHeight = imageRef.current.offsetHeight;

        scrollX = (offsetX * 100) / previewWith;
        scrollY = (offsetY * 100) / previewHeight;
      }

      return {
        zoom: !zoom,
        scrollX,
        scrollY,
      };
    });
  }, []);

  useEffect(() => {
    setLoaded(false);
    setState(initialState);
  }, [url]);

  useEffect(() => {
    const { scrollX, scrollY } = state;

    let image = imageRef.current;
    let container = containerRef.current;

    container.scrollLeft = (scrollX * image.offsetWidth) / 100 - container.offsetWidth / 2;
    container.scrollTop = (scrollY * image.offsetHeight) / 100 - container.offsetHeight / 2;
  }, [state]);

  return (
    <ElementRoot
      ref={containerRef}
      loaded={loaded}
      zoom={state.zoom}
    >
      <span>
        <img
          ref={imageRef}
          className="original"
          src={url}
          onLoad={handleLoad}
          onClick={zoomImage}
        />
      </span>
    </ElementRoot>
  );
};

ImagePreview.propTypes = mediaElementShape;

ImagePreview.displayName = "ImagePreview";
